module.exports = __webpack_public_path__ + "img/mz.f1049422.svg";